/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FilterOrganisationMembersChipsQueryVariables = Types.Exact<{
  userIds: Array<Types.Scalars['ID']['input']>;
}>;


export type FilterOrganisationMembersChipsQuery = { organisationMemberships: { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } }> } };


export const FilterOrganisationMembersChipsDocument = gql`
    query FilterOrganisationMembersChips($userIds: [ID!]!) {
  organisationMemberships(
    offset: 0
    limit: 25
    sorting: [{column: firstname, direction: asc}]
    filters: {ids: $userIds}
  ) {
    edges {
      node {
        id
        firstname
        familyname
        avatar {
          ...AttachmentSnapshot
        }
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;

/**
 * __useFilterOrganisationMembersChipsQuery__
 *
 * To run a query within a React component, call `useFilterOrganisationMembersChipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterOrganisationMembersChipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterOrganisationMembersChipsQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *   },
 * });
 */
export function useFilterOrganisationMembersChipsQuery(baseOptions: Apollo.QueryHookOptions<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables> & ({ variables: FilterOrganisationMembersChipsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>(FilterOrganisationMembersChipsDocument, options);
      }
export function useFilterOrganisationMembersChipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>(FilterOrganisationMembersChipsDocument, options);
        }
export function useFilterOrganisationMembersChipsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>(FilterOrganisationMembersChipsDocument, options);
        }
export type FilterOrganisationMembersChipsQueryHookResult = ReturnType<typeof useFilterOrganisationMembersChipsQuery>;
export type FilterOrganisationMembersChipsLazyQueryHookResult = ReturnType<typeof useFilterOrganisationMembersChipsLazyQuery>;
export type FilterOrganisationMembersChipsSuspenseQueryHookResult = ReturnType<typeof useFilterOrganisationMembersChipsSuspenseQuery>;
export type FilterOrganisationMembersChipsQueryResult = Apollo.QueryResult<FilterOrganisationMembersChipsQuery, FilterOrganisationMembersChipsQueryVariables>;